import React from 'react';

import { MenuItem, FormControl, InputLabel } from '@material-ui/core';
import styled from 'styled-components';

import theme from 'constants/theme';

import { Typography4, Typography8 } from 'uiToolkit/Typography';

import { StyledSelect } from './styles';

const LabelSelect = styled(StyledSelect)`
  &.MuiInput-underline:hover:not(.Mui-disabled):before {
    border: 0;
  }
  &.MuiInput-underline:before {
    border: 0;
  }
  &.MuiInput-underline:after {
    border: 0;
  }
  .MuiSelect-select {
    padding: 25px 32px 11px 16px;
  }
  &.MuiInput-formControl {
    margin-top: 0;
  }
  .MuiSelect-icon {
    right: 12px;
  }
`;

const LabelSelectWrapper = styled.div`
  border: 1px solid ${theme.palette.background.lightGrey3};
  border-radius: 4px;
  min-width: 120px;
  max-width: 150px;
  margin-left: 24px;
`;

const StyledMenuItem = styled(MenuItem)`
  padding-left: 24px;
  padding-right: 24px;
  &:hover {
    background: none;
    .MuiTouchRipple-root {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }

  &.Mui-selected {
    background: none;
    &:hover {
      background: none;
    }
    .MuiTouchRipple-root {
      background-color: rgba(0, 0, 0, 0.08);
    }
  }
`;

const StyledInputLabel = styled(InputLabel)`
  &.MuiInputLabel-formControl {
    transform: none;
    top: 6px;
    left: 16px;
  }
`;

const LabelStyledSelect = ({ selectedValue, options, handleOptionsChange, labelText = '', disabled = false }) => (
  <LabelSelectWrapper>
    <FormControl fullWidth variant="standard">
      <StyledInputLabel id="select-from" disableAnimation shrink={false}>
        <Typography8 customColor={theme.palette.text.dark1}>{labelText}</Typography8>
      </StyledInputLabel>
      <LabelSelect
        value={selectedValue}
        displayEmpty
        onChange={(e) => handleOptionsChange(e.target.value)}
        width="100%"
        disabled={disabled}
      >
        {options.map((count) => (
          <StyledMenuItem primary value={count}>
            <Typography4 weight={600}>{count}</Typography4>
          </StyledMenuItem>
        ))}
      </LabelSelect>
    </FormControl>
  </LabelSelectWrapper>
);

export default LabelStyledSelect;
